import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Nav from "../main/nav";
import Footer from "../main/footer";

import ImportHeader from "../main/ImportHeader";
import { use } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import DownloadExcel from "../main/DownloadExcel";
import { formatToDateTime } from "../main/formatToDateTime";
import DateRange from "../main/DateRange";

export default function ImportReports() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [type, setType] = useState(searchParams.get("type") || "de_stuffing");
  const [start, setStart] = useState(searchParams.get("start") || "");
  const [end, setEnd] = useState(searchParams.get("end") || "");
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ContainerNo, setContainerNo] = useState(null);
  const [fcl_lcl, setFcl_lcl] = useState("");
  const [delivery_type, setDelivery_type] = useState("");

  const handleFromSubmit = (e) => {
    e.preventDefault();
    setContainerNo(e.target.container_no.value);
    let range = e.target.range.value;
    if (range) {
      let [startDateTime, endDateTime] = range.split(" ~ ");
      setStart(startDateTime);
      setEnd(endDateTime);
    }
    setFcl_lcl(e.target.type.value);
    setDelivery_type(e.target.delivery_type.value);
  };

  const DownLoadData = async () => {
    const transformations = [];
    const columnsToDelete = [
      "rn",
      "id",
      "is_cargo_card_generated",
      "reserve_flag",
      "container_number",
      "container_type",
      "container_size",
      "container_life",
      "cncl_flag",
      "private_or_concor_labour_flag",
      "status",
      "updated_at",
      "created_at",
      "created_by",
      "integration_flag",
      "read_flag",
      "status_flag",
      "cycle_flag",
    ];
    const fileName = type.toUpperCase(); // destuffing / delivery

    try {
      let allData = [];
      let currentPage = 1;
      let totalPages = 1;

      do {
        const response = await fetch(
          `https://ctas.live/backend/api/${type}/transaction?page=${currentPage}`
        );
        const result = await response.json();

        if (result.status === "success") {
          allData = [...allData, ...result.data.data];
          totalPages = result.data.last_page;
        }
        currentPage++;
      } while (currentPage <= totalPages);

      DownloadExcel(allData, columnsToDelete, fileName, transformations);
    } catch (error) {
      console.error("Error fetching all data:", error);
    }
  };

  useEffect(() => {
    GetData();
  }, [type, ContainerNo, start, end, fcl_lcl,delivery_type]);

  const GetData = async (page = 1) => {
    setLoading(true);
    let url = `https://ctas.live/backend/api/${type}/transaction?page=${page}`;
    if (ContainerNo) {
      url += `&container_no=${ContainerNo}`;
    }
    if (start) {
      url += `&start=${start}`;
    }
    if (end) {
      url += `&end=${end}`;
    }
    if (fcl_lcl) {
      url += `&type=${fcl_lcl}`;
    }
    if (delivery_type) {
      url += `&delivery_type=${delivery_type}`;
    }
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          // access_token: `${AccessToken}`,
        },
      });
      if (response.data && response.data) {
        setData(response.data.data);
      } else {
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..!`,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <ImportHeader />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">

                <div className="row my-3">
                  <div className="nav-align-top">
                    <ul className="nav nav-pills  flex-md-row gap-2 gap-lg-0">
                      <li
                        className="nav-item"
                        onClick={() => {
                          setType("de_stuffing");
                        }}
                      >
                        <p
                          className={`nav-link border ${
                            type == "de_stuffing" ? "active" : ""
                          } waves-effect waves-light`}
                        >
                          DeStuffing
                        </p>
                      </li>
                      <li
                        className="nav-item"
                        onClick={() => {
                          setType("delivery");
                        }}
                      >
                        <p
                          className={`nav-link border ${
                            type == "delivery" ? "active" : ""
                          } waves-effect waves-light`}
                        >
                          Delivery
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="row justify-content-between my-5">
                  <div className="card">
                    <div className="card-body">
                      <form
                        className="needs-validation"
                        noValidate=""
                        onSubmit={handleFromSubmit}
                      >
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-3">
                              <input
                                type="text"
                                name="container_no"
                                placeholder="Container No."
                                className="form-control"
                                value={ContainerNo}
                                onChange={(e) => setContainerNo(e.target.value)}
                              />
                              <label
                                className="form-label"
                                htmlFor="bs-validation-country"
                              >
                                Container No.
                              </label>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-floating form-floating-outline mb-3">
                              <DateRange />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline mb-3">
                              <select
                                name="type"
                                className="form-select"
                                value={type}
                                onChange={(e) => setFcl_lcl(e.target.value)}
                              >
                                <option value="">All</option>
                                <option value="FCL">FCL</option>
                                <option value="LCL">LCL</option>
                              </select>
                              <label className="form-label" htmlFor="type">
                                Type
                              </label>
                            </div>
                          </div>
                          {type == "delivery" && (
                            <div className="col-md-2">
                            <div className="form-floating form-floating-outline mb-3">
                              <select
                                name="delivery_type"
                                className="form-select"
                                value={delivery_type}
                                onChange={(e) => setDelivery_type(e.target.value)}
                              >
                                <option value="">All</option>
                                <option value="Direct">Direct Delivery</option>
                                <option value="Normal">Delivery</option>
                              </select>
                              <label className="form-label" htmlFor="delivery_type">
                                Delivery Type
                              </label>
                            </div>
                          </div>
                          )}
                          <div className="col-md-3">
                            <button
                              type="submit"
                              className="btn btn-label-primary waves-effect waves-light me-1"
                            >
                              <i className="ri-arrow-right-line ri-20px" />
                            </button>
                            <a
                              href="?"
                              type="button"
                              className="btn btn-label-primary waves-effect waves-light me-1"
                            >
                              <i className="ri-restart-line ri-20px" />
                            </a>
                            <button
                              type="button"
                              className="btn btn-label-primary waves-effect waves-light me-1"
                              onClick={() => DownLoadData()}
                            >
                              <i class="ri-download-fill"></i>
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="card">
                    <div className="card-body px-1">
                      <div className="table-responsive text-nowrap">
                        {type == "de_stuffing" ? (
                          <table className="table table-hover table-striped table-sm">
                            <thead>
                              <tr className="table-primary">
                                <td>SN</td>
                                <td>Type</td>
                                <td>Container No</td>
                                <td>Size</td>
                                <td>Job Order No</td>
                                <td>ICD Location</td>
                                <td>Package Weight</td>
                                <td>No Of Package</td>
                                <td>Bill Of Entry/Bill Of Lading</td>
                                <td>Grid Area</td>
                                <td>Seal No</td>
                                <td>Sline Code</td>
                                <td>Start DateTime</td>
                                <td>End DateTime</td>
                                <td>Handling Type</td>
                                <td>Importer/Forwarder Name</td>
                                <td>Cha Code</td>
                              </tr>
                            </thead>
                            <tbody>
                              {Data?.data?.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.rn}</td>
                                  <td>{item.type}</td>
                                  <td>
                                    {item.container_number}{" "}
                                    <Link
                                      to={`/deStuffing/tallySheet?id=${item.id}&type=${item.type}&container_no=${item.container_number}`}
                                    >
                                      <i className="ri-eye-line ri-22px"></i>
                                    </Link>
                                  </td>
                                  <td>{item.container_size}</td>
                                  <td>{item.destuffing_job_order}</td>
                                  <td>{item.icd_location_code}</td>
                                  <td>
                                    {item.de_stuffing_bill_details
                                      ?.reduce(
                                        (total, detail) =>
                                          total +
                                          (parseFloat(detail.package_weight) ||
                                            0),
                                        0
                                      )
                                      .toFixed(2)}
                                  </td>
                                  <td>
                                    {item.de_stuffing_bill_details?.reduce(
                                      (total, detail) =>
                                        total +
                                        (parseInt(
                                          detail.no_of_packages_declared
                                        ) || 0),
                                      0
                                    )}
                                  </td>
                                  <td>
                                    {item?.de_stuffing_bill_details?.map(
                                      (details, i) => (
                                        <small className="d-block">
                                          {details.boe_number ??
                                            details.bol_number}{" "}
                                        </small>
                                      )
                                    )}
                                  </td>
                                  <td>
                                    {item?.de_stuffing_bill_details?.map(
                                      (details, i) =>
                                        details?.grid_area?.map((grid, k) => (
                                          <small
                                            key={`${i}-${k}`}
                                            className="d-block"
                                          >
                                            {grid?.grid_locations}: {grid?.area}
                                          </small>
                                        ))
                                    )}
                                  </td>

                                  <td>{item?.seal_number}</td>
                                  <td>{item?.shipping_liner_code}</td>
                                  <td>{formatToDateTime(item?.start_time)}</td>
                                  <td>{formatToDateTime(item?.end_time)}</td>
                                  <td>{item?.handling_type}</td>
                                  <td>
                                    {[
                                      ...new Set(
                                        item?.de_stuffing_bill_details?.map(
                                          (d) => d.importer_name
                                        )
                                      ),
                                    ]?.map((importer) => (
                                      <small className="d-block">
                                        {importer}
                                      </small>
                                    ))}
                                  </td>
                                  <td>
                                    {item?.de_stuffing_bill_details?.map(
                                      (de, i) => (
                                        <>
                                          <span>
                                            {de.cha_code
                                              ? `${de.cha_code},`
                                              : ""}
                                          </span>
                                          {(i + 1) % 3 === 0 && <br />}
                                        </>
                                      )
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <table className="table table-hover table-striped table-sm">
                            <thead>
                              <tr className="table-primary">
                                <td>SN</td>
                                <td>Type</td>
                                <td>Container No</td>
                                <td>Size</td>
                                <td>GPM Number</td>
                                <td>ICD Location</td>
                                <td>Package Weight</td>
                                <td>No Of Package</td>
                                <td>Truck No.</td>
                                <td>Bill Of Entry/Bill Of Lading</td>
                                <td>Grid Area</td>
                                <td>Sline Code</td>
                                <td>Start DateTime</td>
                                <td>End DateTime</td>
                                <td>Handling Type</td>
                                <td>Cha Code</td>
                              </tr>
                            </thead>
                            <tbody>
                              {/* {data && data.data.length > 0 ? ( */}
                              {Data?.data?.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.rn}</td>
                                  <td>{item.type}</td>
                                  <td>
                                    {item.container_number}

                                    <Link
                                      to={`/delivery/tallySheet?id=${item.id}&gpm_number=${item.gpm_number}&container_no=${item.container_number}`}
                                    >
                                      <i className="ri-eye-line ri-22px"></i>
                                    </Link>
                                  </td>
                                  <td>{item.container_size}</td>
                                  <td>{item?.gpm_number}</td>
                                  <td>{item.icd_location_code}</td>
                                  <td>
                                    {item.delivery_trucks
                                      ?.reduce(
                                        (total, detail) =>
                                          total +
                                          (parseFloat(detail.pkgs_weight) || 0),
                                        0
                                      )
                                      .toFixed(2)}
                                  </td>
                                  <td>
                                    {item.delivery_trucks?.reduce(
                                      (total, detail) =>
                                        total +
                                        (parseInt(detail.no_of_pkgs) || 0),
                                      0
                                    )}
                                  </td>
                                  <td>
                                    {item?.delivery_trucks?.map(
                                      (truck, key) => (
                                        <span className="d-block">
                                          {truck?.truck_number}
                                        </span>
                                      )
                                    )}
                                  </td>
                                  <td>
                                    {[
                                      ...new Set(
                                        item?.delivery_trucks?.map(
                                          (details, i) => details.boe
                                        )
                                      ),
                                    ]?.map((boe, i) => (
                                      <>
                                        <span>{boe}, </span>
                                        {(i + 1) % 3 === 0 && <br />}
                                      </>
                                    ))}
                                  </td>
                                  <td>
                                    {item?.delivery_trucks?.map((details, i) =>
                                      details?.grid_area?.map((grid, k) => {
                                        if (grid?.grid_locations === "direct") {
                                          if(i==0){
                                            return 'Direct Delivery';
                                          }
                                        }else{
                                          return (
                                            <small
                                              key={`${i}-${k}`}
                                              className="d-block"
                                            >
                                              {grid?.grid_locations}:{" "}
                                              {grid?.area}
                                            </small>
                                          );
                                        }
                                      })
                                    )}
                                  </td>
                                  <td>{item?.shipping_line_code}</td>
                                  <td>
                                    {item?.start_time &&
                                      formatToDateTime(item?.start_time)}
                                  </td>
                                  <td>
                                    {item?.end_time &&
                                      formatToDateTime(item?.end_time)}
                                  </td>
                                  <td>{item?.handling_type}</td>
                                  <td>{item?.cha_code}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}

                        {Data && Data?.data && (
                          <div className="container mt-4">
                            <div className="row">
                              <div className="col-sm-12 col-md-6">
                                <div
                                  className="dataTables_info"
                                  id="DataTables_Table_0_info"
                                  role="status"
                                  aria-live="polite"
                                >
                                  Showing {Data.from} to {Data.to} of{" "}
                                  {Data.total} entries
                                </div>
                              </div>
                              <div className="col-10 m-auto mt-2">
                                <div
                                  className="dataTables_paginate paging_simple_numbers"
                                  id="DataTables_Table_0_paginate"
                                >
                                  <ul className="pagination ">
                                    {Data &&
                                      Data?.links &&
                                      Data?.links?.map((link, q) => {
                                        let showData =
                                          Data.links.length == q + 1
                                            ? "Next"
                                            : q == 0
                                            ? "Previous"
                                            : link.label;
                                        return (
                                          <li
                                            key={q}
                                            className={`paginate_button page-item ${
                                              link.active === true
                                                ? "active"
                                                : ""
                                            }  ${
                                              showData == "Next" &&
                                              Data.current_page ==
                                                Data.last_page
                                                ? "disabled"
                                                : showData == "Previous" &&
                                                  Data.current_page == 1
                                                ? "disabled"
                                                : ""
                                            } `}
                                          >
                                            <button
                                              onClick={() => {
                                                showData == "Previous"
                                                  ? GetData(
                                                      Data.current_page - 1
                                                    )
                                                  : showData == "Next"
                                                  ? GetData(
                                                      Data.current_page + 1
                                                    )
                                                  : GetData(link.label);
                                              }}
                                              aria-controls="DataTables_Table_0"
                                              role="link"
                                              aria-current="page"
                                              data-dt-idx={0}
                                              tabIndex={0}
                                              className="page-link"
                                            >
                                              {showData}
                                            </button>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
}
